// @ts-nocheck

import { createSelector } from 'reselect';

import { GRChipStatuses } from '../../types/chip';
import { selectGRMiscCurrentNotification } from '../misc';
import { selectGRBetsFromRound, selectGRPointsBySumFromRound, selectMaxPointsGRSpecificRule } from '../round';

const selectPoints = createSelector(
  [selectGRMiscCurrentNotification, selectGRPointsBySumFromRound, selectGRBetsFromRound],
  (currNotif, pointsFromState, bets) => {
    if (currNotif) {
      const { data: currNotifData } = currNotif ?? {};
      const { betslipReference: currNotifBetslipRef, nextStatus: currNotifNextStatus } = currNotifData ?? {};
      const currNotifIndexFromBets = bets.findIndex((bet) => bet.betslipReference === currNotifBetslipRef);

      if (currNotifIndexFromBets !== -1) {
        const previousTotalPointsFromCurrNotif = bets.reduce((acc, bet, i) => {
          if (i < currNotifIndexFromBets && bet.status === GRChipStatuses.WON && bet.counted) {
            return acc + bet.points;
          }

          return acc;
        }, 0);

        const { points: betPoints, counted: betCounted } = bets[currNotifIndexFromBets];

        if (currNotifNextStatus === GRChipStatuses.LOST && betCounted) {
          return 0;
        }

        if (currNotifNextStatus === GRChipStatuses.WON && betCounted) {
          return previousTotalPointsFromCurrNotif + betPoints;
        }

        return previousTotalPointsFromCurrNotif;
      }
    }

    return pointsFromState;
  },
);

const selectGRProgressBarProps = createSelector([selectMaxPointsGRSpecificRule, selectPoints], (maxPoints, points) => ({
  maxPoints,
  points: Math.min(maxPoints, points),
}));

export default selectGRProgressBarProps;
